/**
 * Gallery Modal (close only)
 * - クリックで開閉
 * - ESC / 背景クリック / 閉じるボタンで閉じる
 * - body scroll lock / marquee 一時停止
 */

let state = {
  images: [],
  index: 0,
  modal: null,
  dialog: null,
  imgEl: null,
  lastActive: null
};

function createModalOnce() {
  if (state.modal) return;

  const modal = document.createElement('div');
  modal.className = 'c-modal';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-label', '画像プレビュー');

  modal.innerHTML = `
    <div class="c-modal__dialog" tabindex="-1">
      <div class="c-modal__img-wrap">
        <img class="c-modal__img" alt="">
      </div>
      <button class="c-modal__close" type="button" aria-label="閉じる">
        <span class="c-modal__icon"></span>
      </button>
    </div>
  `;

  document.body.appendChild(modal);

  state.modal = modal;
  state.dialog = modal.querySelector('.c-modal__dialog');
  state.imgEl = modal.querySelector('.c-modal__img');

  // 背景クリックで閉じる（ダイアログ外のみ）
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  // ボタン操作
  modal.querySelector('.c-modal__close').addEventListener('click', closeModal);

  // キーボード
  window.addEventListener('keydown', (e) => {
    if (!state.modal?.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeModal();
  });
}

function openModal(index = 0) {
  createModalOnce();
  state.index = index;
  state.lastActive = document.activeElement;

  const item = state.images[index];
  const large = item.dataset.large || item.src;
  const alt = item.alt || '';
  state.imgEl.src = large;
  state.imgEl.alt = alt;

  state.modal.classList.add('is-open');
  document.body.classList.add('is-modal-open');
  state.dialog.focus({ preventScroll: true });
}

function closeModal() {
  state.modal?.classList.remove('is-open');
  document.body.classList.remove('is-modal-open');

  if (state.lastActive && typeof state.lastActive.focus === 'function') {
    state.lastActive.focus({ preventScroll: true });
  }
}

export function initGalleryModal(scope = document) {
  const imgs = scope.querySelectorAll('.p-top-gallery__marquee .c-marquee__item img');
  state.images = Array.from(imgs);

  state.images.forEach((img, idx) => {
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', (e) => {
      e.preventDefault();
      openModal(idx);
    });
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) closeModal();
  });
}

// 自動初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initGalleryModal());
} else {
  initGalleryModal();
}
